import { useMemo } from 'react';
import type { ComponentType } from 'react';

import { illustrationUrlOf } from '../utils/illustration-url.util';
import type { IllustrationProps } from '../types/props.type';

import { useIllustrationColor } from './useIllustrationColor.hook';

export const useIllustrationUrl = (
  Illustration: ComponentType<IllustrationProps>,
): string => {
  const color = useIllustrationColor(undefined);

  return useMemo(
    () => illustrationUrlOf(Illustration, color),
    [Illustration, color],
  );
};
